import { atom, useAtomValue, useSetAtom } from "jotai";
import type { Opaque } from "type-fest";
import { nanoid } from "utils/nanoid";

export type DialogId = Opaque<string, "DialogId">;

const confirmDialogIdsState = atom<Set<DialogId>>(new Set<DialogId>());

export const makeDialogId = () => {
  return nanoid() as DialogId;
};

export const useConfirmDialogIdsStateValue = () => {
  return useAtomValue(confirmDialogIdsState);
};

export const useSetConfirmDialogIdsState = () => {
  return useSetAtom(confirmDialogIdsState);
};
